import jaLocale from 'element-ui/lib/locale/lang/ja';
import jaPrototypes from '@/prototypes/index.lang.ja';
import jaValidator from './ja_validator';

export default {
  ...jaLocale,
  ...jaPrototypes,
  ...jaValidator,

  // Common
  Type: 'タイプ',
  'Account Name': 'アカウント名',
  'Account ID': 'アカウントID',
  'Usage Details': 'ご利用明細',
  'Something went wrong !': 'エラーが発生しました。',

  // Header
  Documents: 'ドキュメント',

  // Dashboard
  'Report data': 'レポートデータ',
  'Invoice data': '請求書データ',
  Preparing: '準備中...',
  'Preparing data': 'データ準備中...',

  // Chart
  Range: 'レンジ',
  Category: 'カテゴリー',
  Cost: 'コスト',
  'Show total': 'トータル表示',
  Filter: 'フィルター',
  FILTER: 'フィルター',
  Daily: 'デイリー',
  Monthly: 'マンスリー',
  Service: 'サービス',
  Account: 'アカウント',
  Blended: 'ブレンド',
  Unblended: '非ブレンド',
  'True Unblended': 'True Unblended',
  'Select All': '全て選択',
  'Deselect All': '全て解除',
  'Search service by name': 'サービスを名前で検索',

  // Summary
  total: '合計',
  average: '平均',

  // Change Password
  Password: 'パスワード',
  '{min}~{max} characters': '{min}～{max} 文字',
  'New Password': '新しいパスワード',
  Confirm: '確認用',
  'Confirm Password': '確認用パスワード',
  'Confirm submit': '確認する',
  Back: '戻る',
  'Reset password': 'パスワードの再設定',
  'Check email address': 'メールアドレス確認',
  'Verification code': '認証コード',
  Reset: 'リセット',
  'Please type email address.': 'メールアドレスを入力してください。',
  'This email address does not exist.': '存在しないメールアドレスです。',
  'An error has occurred.': 'エラーが発生しました。',
  'Verification code will be sent to the email address you typed.':
    'さきほど入力したメールアドレス宛に認証コードが届きます。',
  'Please enter a email address to the form below.':
    'メールアドレスを確認するため下のフォームにメールアドレスを入力してください。',
  'Six digits verification code will be sent to the email address from Alphaus.':
    '確認が完了すると『6桁の有効期限認証コード』が記載されているメールがAlphausから送信されます。',
  'The verification code is valid for 900 seconds.': '認証コードの有効期限は900秒です。',
  'If the verification code is expired, send the email again.':
    '有効期限が切れた場合はメールを再送してください。',
  'Send email again.': 'メールを再送する',
  'Six-digit verification code': '6桁の認証コード',
  'Type Six-digit verification code.': '6桁の認証コードを入力してください。',
  'This is wrong verification code.': '誤った認証コードです。',
  'Type new password.': '新しいパスワードを入力してください。',
  'Change password': 'パスワードを変更',
  'Failed to change password.': 'パスワードの変更に失敗しました。',
  'Password was reset.': 'メールアドレスの再設定が完了しました。',
  'Go to login page.': 'ログイン画面へ',

  // Change Login ID
  'Email address is already exist.': 'このメールアドレスは既に使用されています。',

  // Upper menu
  Settings: '設定',

  // Notification Settings
  //'Notification destination setting': '通知先の設定',
  //'Email address': 'メールアドレス',
  //Slack: 'Slack',
  //'Email notification': 'メール通知',
  //'Slack notification': 'Slack通知',
  //'Please enter the correct e-mail address.': '正しいメールアドレスを入力してください。',
  //'Please enter the correct URL.': '正しいURLを入力してください。',
  //"Please check Slack's webhooks documentation for further information.":
  //  'webhookの設定に関しては公式のドキュメントを参照してください。',

  // Additional Settings
  'Past setting': '過去の設定',
  'The rate you entered here are used for monthly usage & report generation (the csv you can download).On UI it will by default showing the original USD price.':
    'ここに入力した料金は、毎月の使用量とレポートの生成に使用されます（CSVはダウンロードできます）。 UIではデフォルトでUSD価格が表示されます。',

  // User setting
  //'Open sub user management': 'ユーザー管理画面を開く',

  // Account
  Accounts: 'アカウント',
  'Payer account': '親アカウント',
  'Account menu': 'アカウントメニュー',
  // 'Account information': 'アカウント情報',
  'Edit account info': 'アカウント情報の変更',
  //'You can download whole account report in one csv. Select the month and click "Bulk download".':
  //  'すべてのアカウントのレポートを一括でダウンロードできます。ダウンロードする月を選択して『一括ダウンロード』をクリックしてください。',
  //'No existing data.': 'データが存在しません。',
  //'Bulk download': '一括ダウンロード',
  //'Report bulk download': 'レポート一括ダウンロード',
  //'Select the month': '月を選択してください',
  'Search account': 'アカウントの検索',
  'Download report': 'レポートのダウンロード',
  'Download the selected report (.csv)': '選択月のレポート（.csv）のダウンロード',
  'Setup a limit on your AWS account monthly and daily spending. Notify you when reaching the limit.':
    'AWSアカウントの毎日・毎月の予算設定ができます。設定した予算を超えた場合、登録したメールアドレスに通知されます。',
  //'Extra information': 'その他の明細情報',
  'Check information': 'その他の明細情報を確認',
  'Owns Active RI': 'アクティブなリザーブドインスタンス保有中',
  //Subscription: 'サブスクリプション',
  //Credit: 'クレジット',
  //Refund: '返金',
  //'You can check the fee for subscriptions payment, AWS credit, refund.':
  //  'サブスクリプション支払い額、AWSクレジット、返金の情報を確認できます。',
  //'Any upfront annual fee that you paid like RI upfront fee, Marketplace fee.. etc':
  //  '「全前払いRI」や「一部前払いRI」などの前払い年間料金。',
  //"Any credits that AWS applied to user's bill.": 'AWS が請求に適用したすべてのクレジット。',
  //'Negative charges that AWS refunded money to user for.':
  //  'AWS から負の課金として払い戻される金額。',

  // Group
  'Create new group': 'グループを作成',
  'Account group': 'アカウントグループ',
  'Tag group': 'タググループ',
  'Group name': 'グループ名',
  'Group name is required.': 'グループ名は必須です。',
  'Account group? Tag Group?': 'グループの種類',
  'Input group name': 'グループ名の入力',
  'Please input group name.': 'グループ名を入力してください。',
  'Up to 20 characters': '20字以内',
  required: '必須',
  'Select account group or tag group.':
    'アカウントグループもしくはタググループを選択してください。',
  'Choose account you want to add': '追加するアカウントの選択',
  'Move the accounts you want to add into group to the right.':
    'グループに追加するアカウントを右側へ移動してください。',
  'Search group': 'グループの検索',

  // Tag
  Tag: 'タグ',
  'Tag name': 'タグ名',
  'Tag value': 'タグバリュー',
  'Tag values': 'タグバリュー',
  'Tag list': 'タグリスト',
  'Select Tag Value to display':
    'データ取得対象のTag valueを選択してください。（50個まで選択可能）',
  'Select Tag Value': 'Tag valueを選択してください。',
  'No active tags': 'アクティブなタグがありません',
  'No tag values': 'Tag valueがありません',
  'Activated!': 'タグを有効にしました',
  'Tag values and usage data will be ready in two days.':
    'Tag valueと利用データの準備には２日程度かかります。',
  'Failed to get Tag value data.': 'Tag valueデータの取得に失敗しました',
  'Select all': 'すべてを選択する',
  //'Save Changes': '設定を保存',
  Close: '閉じる',
  Cancel: 'キャンセル',
  'Search active tag': 'アクティブなタグを検索',
  'Search inactive tag': 'アクティブではないタグを検索',
  'Select tag value': 'Tag valueを選択',
  'Edit tag values': 'タグバリューの編集',

  // Budget
  //'Setting per day': '日毎の設定',
  //'Setting per month': '月毎の設定',
  //'Budget for a day': '１日の予算',
  //'Day-over-day changes': '前日比',
  //'Budget for a month': '１ヶ月の予算',
  //'Budget was set': '予算の設定を変更しました',
  //Percent: 'パーセント',
  //Dollar: 'ドル',

  // Report Filters
  'Report Filters': 'レポートフィルター',
  Attribute: '値の選択',
  'Filter Tags': 'タグのフィルター設定',
  'Filter Name': 'フィルタ名',
  'Save Filter': 'フィルターを保存',
  'Please note that the results shown in the "Preview" and "Show results" sections are based on the current month.':
    'なお、「プレビュー」「結果の表示」で表示される結果は、当月を基準としています。',
  'Show Results': '結果を表示',
  Preview: 'プレビュー',
  'Group Accounts': '結果をグルーピング',
  'Tag Value': 'タグバリュー',
  'Filter Accounts': 'アカウントのフィルターの設定',
  'Add Filter (or)': 'フィルターを追加（OR）',
  'Are you sure you want to delete this filter?': 'フィルターを削除確認用 ?',
  'Please select a category first': 'カテゴリを選択してください',
  'Select a Category to Add': '追加するカテゴリを選択してください',
  'Please specify report columns': 'レポートの列を指定してください',

  // RI
  'Failed to get RI data.': 'RIデータの取得に失敗しました',
  instance_type: 'インスタンスタイプ',
  count: 'カウント',
  start: '購入日',
  end: '期限',
  payment_options: '支払いオプション',
  upfront_value: '前払い金額',
  cycle_fee: 'サイクル料金',
  Quantity: '量',
  unblended_rate: 'アンブレンデッド プライス',
  account_name: 'アカウント名',
  account_id: 'アカウント ID',
  region: 'リージョン',
  scope: 'スコープ',
  platform: 'プラットフォーム',
  'Active RI': 'アクティブなRI',
  Expired: '期限切れ',
  'Search RI': 'リザーブドインスタンスを検索する',
  "It will turn green when last month's report is ready.":
    '先月分のレポートデータの準備ができている場合、緑に点灯します。',
  "It will turn green when last month's invoice is ready.":
    '先月分の請求書の準備ができている場合、緑に点灯します。',
  'Copy to clipboard': 'クリップボードにコピー',
  'Copied to clipboard': 'クリップボードにコピーしました',
  'Reserved Instance details': 'リザーブドインスタンスの詳細',
  'Add filter': 'フィルターを追加',
  'usage time': '総稼働時間',
  'covered time': 'RI適用時間',
  'utilization rate': '適用率',
  'search ri': 'リザーブドインスタンスを検索',
  'more than 100': '100%以上',
  'search ri recommendation': 'RI Recommendationsを検索',
  'on demand cost': 'オンデマンドコスト',
  'discounted cost': '削減後のコスト',
  'Saving cost': '削減コスト',
  Percentage: '削減率',
  'Current cost and discounted cost.': '現在の使用コストと削減後のコストです。',
  'average monthly discounted cost': '月平均削減コスト',
  'average yearly discounted cost': '年間削減コスト',
  'Average monthly and yearly discounted cost estimate.':
    'おおよその月平均削減コストと年間削減コストです。',
  'Month selection': '月の選択',
  Class: 'クラス',
  'Select the class. (Currently only "standard" is supported)':
    'クラスを選択してください。（現在は「スタンダード」のみサポートしています）',
  Standard: 'スタンダード',
  Convertible: 'コンバーティブル',
  standard: 'スタンダード',
  convertible: 'コンバーティブル',
  'Select the payment option.': '支払いオプションを選択してください。',
  'All Upfront': '全額前払い',
  'Partial Upfront': '一部前払い ',
  'No Upfront': '前払いなし',
  Term: '期間',
  '1 year': '1年',
  '3 years': '3年',
  // '1yr': '１年間',
  // '3yr': '３年間',
  'Select the term. (Currently only "1 year" is supported)':
    '期間を選択してください。（現在は「1年」のみサポートしています）',
  Recommendation: 'レコメンド',
  'Recommendation (BETA)': 'レコメンデーション（BETA)',
  'size flexibility': 'サイズフレキシビリティ',
  'normalization factor': 'ノーマライゼーションファクター',
  'Availability zone': 'アベイラビリティーゾーン',
  'Cost before tax': '金額（税抜）',
  'Standard 1 year Partial upfront': 'スタンダード１年間・一部前払い',
  'Standard 1 year Full upfront': 'スタンダード１年間・全額前払い',
  'Standard 1 year No upfront': 'スタンダード１年間・前払いなし',
  'Standard 3 years Partial upfront': 'スタンダード３年間・一部前払い',
  'Standard 3 years Full upfront': 'スタンダード３年間・全額前払い',
  'Standard 3 years No upfront': 'スタンダード３年間・前払いなし',
  'Convertible 1 year Partial upfront': 'コンバーティブル１年間・一部前払い',
  'Convertible 1 year Full upfront': 'コンバーティブル１年間・全額前払い',
  'Convertible 1 year No upfront': 'コンバーティブル１年間・前払いなし',
  'Convertible 3 years Partial upfront': 'コンバーティブル３年間・一部前払い',
  'Convertible 3 years Full upfront': 'コンバーティブル３年間・全額前払い',
  'Convertible 3 years No upfront': 'コンバーティブル３年間・前払いなし',
  'Standard 1 year Medium': 'スタンダード１年間・中度使用',
  'Standard 1 year Heavy': 'スタンダード１年間・重度使用',
  'Standard 3 years Medium': 'スタンダード３年間・中度使用',
  'Standard 3 years Heavy': 'スタンダード３年間・重度使用',
  'Convertible 1 year Medium': 'コンバーティブル１年間・中度使用',
  'Convertible 1 year Heavy': 'コンバーティブル１年間・重度使用',
  'Convertible 3 years Medium': 'コンバーティブル３年間・中度使用',
  'Convertible 3 years Heavy': 'コンバーティブル３年間・重度使用',

  // Savings Plan
  'Savings Plan Type': 'Savings Plan タイプ',
  'Savings Plans': 'Savings Plans',
  Commitment: 'コミットメント',
  'Instance Family': 'インスタンスファミリー',
  'Upfront Cost': '前払いコスト',
  'Monthly Recurring Charges': '毎月の定額料金',
  'Purchase Term': '期間',
  'Active SP': 'アクティブなSP',
  'Search Savings Plan': 'Savings Planを検索',
  'EC2 Instance on': 'EC2 インスタンス',
  Compute: 'コンピューティング',
  Hour: '時間',
  'Payment Option': '支払いオプション',
  Currency: '通貨',
  '1yr': '1年',
  '3yr': '3年',
  '2yr': '2年',
  year: '年',
  'Purchase term': '期間',
  'All savings plan': '全てのSavings Plan',
  'All payment options': 'すべての支払いオプション',
  'All purchase terms': 'すべての購入条件',
  'All regions': 'すべての地域',
  'All accounts': ' すべてのアカウント',
  ComputeSavingsPlans: 'Compute',
  EC2InstanceSavingsPlans: 'EC2 Instance',

  // Billing reports
  'Monthly total cost': '当月の合計金額',
  // 'Usage Quantity': '使用量',
  // 'Total Charge(USD)': '金額(USD)',
  // 'Type/Region': 'タイプ/リージョン',

  text: {
    dashboard: 'ダッシュボード',
    login: 'ログイン',
    logout: 'ログアウト',
    username: 'ユーザー名',
    login_id: 'ログインID',
    password: 'パスワード',
    settings: '設定',
    change_settings: '設定の変更',
    change: '変更する',
    email_address: 'メールアドレス',
    setting_email: 'メールアドレスの設定',
    current_password: '現在のパスワード',
    new_password: '新しいパスワード',
    language: '言語 (Language)', // コードのフッターに「備考」1をご参考。 - Please look at Remark 1 in the footer of source code
    //general_settings: '環境設定',
    //user_settings: 'ユーザーの管理',
    //account_settings: 'アカウント設定',
    //security_settings: 'セキュリティ',
    //access_token_settings: 'API アクセストークン',
    //identity_provider_settings: 'IdP 設定',
    //notification_settings: '通知設定',
    private_price_setting: 'プライベートプライスの設定',
    total: '合計',
    updated: '更新',
    back_to_dashboard: 'ダッシュボードへ戻る',
    instance_type: 'インスタンスタイプ',
    type: 'タイプ',
    region: 'リージョン',
    action: 'アクション',
    option: 'オプション',

    expire: '期限',
    expired: '期限切れ',
    details: '詳細',

    select_value: '選択してください',
    last_month: '前月',
    last_month_cost: '前月の利用料',
    last_last_month: '前前月',
    diff_of_previous_month: '前月比',
    diff_of_last_last_month: '前前月との差',
    this_month: '今月',
    month_to_date: '過去1ヶ月間',
    yesterday: '前日',
    date: '日付',

    show_more: '詳細を見る',
    services_all: 'すべてのサービス',
    service_name: 'サービス名',

    download_csv: 'CSVダウンロード',

    //usage
    usage_trend_this_month: '今月の利用料推移',
    usage_daily_30days: '過去30日の利用料推移',
    usage_ec2_total: 'EC2トータル利用料',
    usage_amount: '利用料',

    // User Info
    company_id: 'カンパニー ID',
    linked_account: 'アカウント',
    usage_report: 'レポート',
    account: 'アカウント',
    account_by: 'アカウント',
    account_name: 'アカウント名',
    // account_name_edit: 'アカウント名の変更',
    account_list: 'アカウントリスト',
    account_id: 'アカウント ID',
    account_add: 'アカウント追加',
    account_all: 'すべてのアカウント',
    account_add_to_group: 'グループに追加',
    account_add_or_remove: 'アカウントの追加・削除',

    // General Settings
    save: '保存',
    save_changes: '設定を保存',
    close: '閉じる',
    cancel: 'キャンセル',
    notify_by_mail: 'メールで通知を受け取ります',
    notify_by_slack: 'Slackで通知を受け取ります',
    enter_email: '通知を受け取るメールアドレスを入力してください。',
    enter_slack: '通知を受け取るSlackの「webhookURL」を入力してください。',
    //enabled_notify: '通知設定済み',
    additional_settings: 'その他の設定',
    private_price_rate: 'プライベートレート',
    exchange_rate: '為替レート',
    discount_rate: '割引率',

    // Account Settings
    //budget_setting: '予算設定',
    budget_daily: '日毎の予算',
    budget_monthly: '月毎の予算',
    login_id_change: 'ログインID変更',

    // Chart Settings
    chart_settings: 'チャート設定',

    // Overview
    ec2_total: 'EC2トータル利用料',
    go_to_chart_settings: '表示サービスの変更',

    // Group
    //group_by: 'グループ',
    group_add: 'グループの作成',
    group_edit: 'グループの編集',
    group_delete: 'グループ削除',
    group_name: 'グループ名',
    group_edit_name: 'グループ名の変更',

    // Chart
    monthly_trend: 'マンスリートレンド',
    monthly_trend_desc: '月別の利用状況の推移',
    monthly_trend_desc_account: 'アカウント毎の月別の利用状況の推移',
    daily_trend: 'デイリートレンド',
    daily_trend_desc: '日別の利用状況の推移',
    daily_trend_desc_account: 'アカウント毎の日別の利用状況の推移',
    daily_average: '日別データの平均額',
    daily_cumulative: '日別累積データ',

    // RI
    ri: 'リザーブドインスタンス',
    ri_purchased: '購入済み',
    ri_utilization: '適用状況',
    ri_covered: '適用済み',
    ri_uncovered: '未適用',
    ri_top3_allocation: '上位3つのRI適用状況 (前月)',
    ri_allocation: 'RI適用状況',
    ri_show_all_coverages: 'すべての適用状況を見る',

    // Tag
    tag: 'タグ',
    tag_desc: 'タグ毎の利用料推移',
    tag_name: 'タグ名',
    tag_add: 'タグの追加',
    tag_delete: '削除するタグ',
    tag_detach: 'タグの解除',

    // Report
    report: 'レポート',
    //report_desc: '月別およびサービス別の利用レポート',
    report_desc2: 'アカウント毎のレポートの確認',
    report_attention: 'ご利用明細が確定するまでの間、ご利用レポート詳細は参考情報となります。',

    // Invoice
    invoice_page: '請求書',
    invoice_download: '請求書のダウンロード',
    invoice_desc_print: '請求明細の印刷',
    invoice_detail: 'ご利用明細',
    invoice_detail_download: 'ご利用明細の確認',
    invoice_detail_print: 'ご利用明細の印刷',
    invoice_detail_print_attention:
      'InternetExplorerをお使いの方で印刷プレビューが正常に表示されない場合はブラウザメニューの印刷から実行してください。',

    invoice: {
      billing_statement: 'ご請求書',
      billing_items: '内訳',
      tax: '消費税',
      account_total: 'アカウント小計(税抜)',
      sub_total: '小計',
      after_discount: '割引後',
      total: '合計',
      exchange_total: '日本円換算後',
      aws_usage: 'AWS利用料',
      substitution: '請求代行手数料',
      support_business: 'サポートビジネス費用',
    },
    invoice003: {
      billing_statement: 'ご請求書',
      billing_items: '内訳',
      tax: '　　消費税等相当額',
      account_total: '利用料合計',
      account_usage: 'Charges:AWS利用料(MarketPlace利用料除く)',
      account_marketplace: 'Marketplace利用料金',
      sub_total: '小計（税抜）',
      discount_fee: '特別値引',
      after_discount: '値引き後小計 ',
      total: '合計（税込）',
      exchange_total: '日本円換算',
      aws_usage: 'AWS利用料',
      substitution: '請求代行サービス利用料金',
      support_business: 'AWS保守サービス利用料金',
    },

    menu: 'Menu',
    overview: 'Overview',
    account_ranking: 'Account Ranking',
    service_ranking: 'Service Ranking',
    daily: 'Daily',
    monthly: 'Monthly',
  },
  message: {
    no_data: 'データがありません。',
    no_account: 'アカウントがありません',
    no_group: 'グループがありません。「グループの作成」からグループを作成してください。',
    no_tag: 'タグがありません。タグを作成してください。',
    no_active_tags: 'アクティブなタグがありません。',
    no_inactive_tags: 'アクティブではないタグがありません。',
    no_ri_data: 'RIのデータがありません。',
    no_ri_data_desc: 'RI購入希望の方はお問い合わせください。',

    // Group
    group_delete: 'グループを削除します',

    // Tag
    tag_detach: 'タグを解除します',
    release_limit_tag: '制限を解除しますか？',
    supported_number_of_tags: '現在のプランで利用できるタグの数',

    //can_not_be_canceled: 'この操作は取り消しができません。',
    all_data_be_deleted: 'これまでのデータはすべて消去されます。',
    // Invoice
    invoice_is_not_ready: '請求書準備中です。',

    // Budget
    budget_message_02: '※設定を解除する場合は、空白もしくは「0」を入力してください。',

    //information
    info_daily_trend: 'RIデータは考慮されていません。',

    // Settings
    setting_rate: '前月利用分を計算する割引率と為替レートを設定してください。',
    check_private_price_settings: '過去の設定を確認する',
    setting_chart_settings_msg01:
      'ダッシュボードのチャートに表示するサービスを選択できます。現プランでは５つまで選択可能です。',

    // Alert
    alert_this_month_data_no_yet_ready: '今月のデータは、準備ができ次第ご確認いただけます。',

    no_data_no_period: 'データがありません',
  },
  notification: {
    error: 'エラーが起きました',
    success: '成功',
    failed: '失敗',
    registered: '登録しました',
    released: '解除しました',
    saved_settings: '設定を保存しました。',
    changed_settings: '設定を変更しました',
    changed_password: 'パスワードを変更しました',
    changed_failed: '変更に失敗しました',
    input_password: 'パスワードを入力してください。',
    password_wrong: '正しいパスワードを入力してください。',
    group_updated: 'グループを更新しました',
    group_deleted: 'グループを削除しました',
    group_added: '新しいグループを追加しました',

    // Auth
    auth_error: 'アクセス認証エラー',
    auth_expire_msg: 'アクセス認証の有効期限が切れました。再度ログインしてください。',

    // Login
    //username_password_invalid: 'ユーザー名もしくはパスワードが正しくありません。',

    // Tag
    tag_save_success: 'タグを保存しました。',
    tag_save_failed: 'タグの保存に失敗しました。',
    tag_delete_success: 'タグを削除しました。',
    tag_delete_failed: 'タグの削除に失敗しました。',
    tag_updated: 'タグを更新しました',

    // Additional settings
    private_price_rate_success: 'プライベートプライスの設定を保存しました。',
    login_id_change_success: 'ログインIDを変更しました。',
  },
  error_pages: {
    not_found: 'Not found.',
    not_found_content: 'このページは存在しません。',
    home: 'ホームに戻る',
    internal_server_error: 'Internal server error.',
    // internal_server_error_content:
    //   "The Unicorns have taken over. We're doing our best to get them under control and get GitHub back up and running.",
    contact_support: 'お問い合わせページ',
    go_back: '戻る',
  },
};
